import genreObservable from '../../api/genres/observable';
import updateGenres from './updateGenres';
import { IGenre } from '../../types/interfaces/genre';

export default function initGenres() {
  genreObservable.subscribe({
    next: (val: IGenre[]) => {
      updateGenres(val);
    },
    error: () => {
      console.error('Error recovering genres');
    },
    complete: () => {
      return null;
    },
  });
}
